import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Guards a product page (PTI / Core):
//   1. Requires the user to be signed in — sends them to /login with a return path
//   2. For logged-in non-admins, enforces `user.allowed_products`
const ProductRoute = ({ product, children }) => {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (isAdmin) return children;
  const allowed = user.allowed_products || ['pti', 'core', 'streamline'];
  if (!allowed.includes(product)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProductRoute;
